import { fromJS, List, Map } from 'immutable';
import { Delta, PushEvent } from '../../../dto/PushEnvelope';
import { ScoreboardType, Sport } from '../../../dto';
import {
    createOrderedIndex,
    indexById,
    insertToOrderedIndex,
    removeFromOrderedIndex,
    updateIndexedById
} from '../../indexingUtils';

export function onSportsSnapshot(sports: Sport[]) {
    return (db: Map<string, any>) =>
        db.setIn(['sports'], indexById(sports)).setIn(['sportIdsByOrder'], createOrderedIndex(sports, 'order'));
}

export function onScoreboardTypesSnapshot(scoreboardTypes: ScoreboardType[]) {
    return (db: Map<string, any>) => db.setIn(['scoreboardTypes'], indexById(scoreboardTypes));
}

export function onSportPush(event: PushEvent, data: Sport | Delta | { id: string }) {
    switch (event) {
        case PushEvent.CREATED:
            return onCreated(data as Sport);
        case PushEvent.UPDATED:
            return updateIndexedById(data as Delta, 'sports');
        case PushEvent.DELETED:
            return onDeleted(data.id);
        default:
            console.error(`Invalid PushEvent ${event}`);
            return turboLiveDb => turboLiveDb;
    }
}

function onCreated(sport: Sport) {
    return turboLiveDb => {
        const { id, order } = sport;

        return turboLiveDb
            .update('sports', entities => entities?.set(id, fromJS(sport)))
            .update('sportIdsByOrder', List(), insertToOrderedIndex({ id, order }));
    };
}

function onDeleted(marketCategoryId: string) {
    return turboLiveDb => {
        return turboLiveDb
            .update('sports', entity => entity?.delete(marketCategoryId))
            .update('sportIdsByOrder', List(), removeFromOrderedIndex(marketCategoryId));
    };
}
